import React from "react";
import { NavItem } from "../../shared/config/navigation";
import { getPlatformUrl } from "../../shared/config/urls";

interface ZudokuMobileNavigationProps {
  navItems?: NavItem[];
}

export const ZudokuMobileNavigation: React.FC<ZudokuMobileNavigationProps> = ({
  navItems: _navItems = [],
}) => {

  return (
    <>
      {/* Mobile-only back link */}
      <div className="lg:hidden md:hidden">
        <a
          href={`${getPlatformUrl()}/platform/apps`}
          className="flex items-center text-md font-medium transition-colors hover:text-foreground text-muted-foreground pb-4"
          style={{ fontWeight: 500 }}
        >
          <span className="mr-2">&lt;&nbsp;&nbsp;</span>
          <span>Back to Platform</span>
        </a>
      </div>
    </>
  );
};

export default ZudokuMobileNavigation;
